import { Button, Typography } from '@mui/material'

import {
  CreatePostInput,
  Maybe,
  MembershipSubscriptionPlan,
  PostCategoryDetail,
  PostType,
} from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { FileUploadInfo, PostCreateForm } from './PostCreateForm'

export * from './fragments'

export type State = {
  artistId: string
  categories: Maybe<Pick<PostCategoryDetail, 'id' | 'name'>>[]
  plans: Maybe<
    Pick<MembershipSubscriptionPlan, 'planId' | 'title' | 'interval'>
  >[]
  withTwitter: boolean
  resourceType?: PostType
  fileUploadInfo: FileUploadInfo
  thumbnailUploadInfo: FileUploadInfo
  isConnectedTwitter: boolean
  resourcesUploading: boolean
  thumbnailUploading: boolean
  loadingCreatePost: boolean
}

export type Action = {
  onSubmitPost: (inputs: CreatePostInput) => Promise<void>
  onConnectTwitter: () => Promise<void>
}

export const ConsolePostCreateTemplate: Template<State, Action> = ({
  state,
  onSubmitPost,
  onConnectTwitter,
}) => {
  const { t } = useTranslation('consolePostCreate')
  const { router, routerNames, routerPages } = useRouter<{
    resourceType: PostType
  }>()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsolePostCreate} />

      <ConsoleBaseLayout
        header={{
          title: t('title'),
          back: true,
          defaultBackPage: routerPages.ConsolePost,
          right: (
            <Button
              variant="text"
              href={routerPages.ConsoleUnpublishedPosts}
              sx={{ mr: -1, p: 0, width: 80 }}
            >
              <Typography variant="subtitle1" sx={{ color: 'white' }}>
                {t('unposted')}
              </Typography>
            </Button>
          ),
        }}
        margin
      >
        <PostCreateForm
          artistId={state.artistId}
          categories={state.categories}
          plans={state.plans}
          withTwitter={state.withTwitter}
          isConnectedTwitter={state.isConnectedTwitter}
          resourceType={state.resourceType}
          fileUploadInfo={state.fileUploadInfo}
          thumbnailUploadInfo={state.thumbnailUploadInfo}
          resourcesUploading={state.resourcesUploading}
          thumbnailUploading={state.thumbnailUploading}
          onSubmitPost={onSubmitPost}
          loadingCreatePost={state.loadingCreatePost}
          onConnectTwitter={onConnectTwitter}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
